import { useHasDuprPlus } from '@/hooks/useHasFeature'
import { useEffect, useState } from 'react'
import { useLocation, matchPath } from 'react-router-dom'
import { SUBSCRIBER_MODAL_ROUTES } from '@/constants/Routes'

const MODAL_SHOWN_KEY = 'subscribeModalShown'

export const useOpenSubscribeModalOnce = () => {
  const isDuprPlus = useHasDuprPlus()
  const [openSubscribeModal, setOpenSubscribeModal] = useState(false)
  const { pathname } = useLocation()

  useEffect(() => {
    const hasBeenShown = sessionStorage.getItem(MODAL_SHOWN_KEY)
    const onAllowedRoute = SUBSCRIBER_MODAL_ROUTES.some((route) => matchPath(route, pathname))

    if (!isDuprPlus && !hasBeenShown && onAllowedRoute) {
      setOpenSubscribeModal(true)
    } else {
      setOpenSubscribeModal(false)
    }
  }, [isDuprPlus, pathname])

  const handleSubscribeModalClose = () => {
    setOpenSubscribeModal(false)
    sessionStorage.setItem(MODAL_SHOWN_KEY, 'true')
  }

  return { openSubscribeModal, handleSubscribeModalClose }
}
